// @flow

export const CAMPOS_TRANSACOES_CONSYSTE = {
  transacoesConsyste: {
    recebidoEm: false, dataDecisaoPortaria: false, decisaoPortariaDescricao: false,
    custodiado: false, situacaoArquivo: false, classificacaoFiscalGeral: false,
    classificacaoRealizadaPor: false, classificacaoRealizadaEm: false,
    classificacaoObs: false,
  },
};

export const CAMPOS_DESACORDO_SERVICO = {
  desacordoServico: {
    desacordoRealizadoEm: false, desacordoServico: false,
  },
};

export const CAMPOS_EMITENTE = {
  emit: {
    emitCnpj: false, emitNome: false, emitFantasia: false, emitBairro: false,
    emitMunicipio: false, emitIe: false, emitEndUf: false, emitPais: false, emitIest: false,
    emitCnae: false, emitCrt: false, emitIm: false,
  },
};

export const CAMPOS_MANIFESTACAO_DESTINATARIO = {
  manifestacaoDestinatario: {
    manifestacao: false, manifestacaoRealizadaPor: false,
    manifestacaoJustificativa: false, manifestacaoRealizadaEm: false,
    ultimaManifestacaoCd: false,
    },
};

export const CAMPOS_DESTINATARIO = {
  dest: {
    destCnpj: false, destIdEstrangeiro: false, destNome: false, destLogr: false, destNum: false, destCompl: false,
    destIe: false, destEndUf: false, destCep: false, destBairro: false, destMunicipio: false, destPais: false,
    destFone: false, destIndIe: false, destIsuframa: false, destIsuf: false, destIm: false, destEmail: false,
  },
};

export const CAMPOS_DADOS_ITENS = {
  dadosBasicosItens: {
    codigo: false, descricao: false, ncm: false, exTipi: false, unidadeComercial: false,
    gtin: false, unidadeTributavel: false, gtinTributavel: false,
  },
};

export const CAMPOS_DADOS_OPERACAO = {
  dadosOperacao: {
    numeroItem: false, cfopItem: false, beneficioFiscal: false, classIbsZfm: false, qtdComercial: false,
    valorUnitarioComercial: false, valorTotalBruto: false, qtdTributavel: false, valorUnitarioTributavel: false,
    valorFrete: false, valorSeguro: false, valorDesconto: false, outrasDespesas: false, itemCompoeValorTotal: false,
    pedidoNro: false, pedidoItem: false, numeroFci: false, informacoesAdicionaisProduto: false, valorAproxTributos: false,
    codFiscalProduto: false, codOperacaoNff: false, embalagemProduto: false, qtdVolumes: false,
    unidMedidaEmbalagem: false,  indBemMovelusado: false,
  },
};

export const CAMPOS_DADOS_CEST = {
  dadosCest: {
    cest: false, escalaRelevante: false, cnpjFabricante: false,
  },
};

export const CAMPOS_CARGA = {
  basicoCarga: {
    valorTotalCarga: false, produtoPredominante: false, outrasCaracteristicas: false,
  },
  docCargaNf: {
    romaneioNf: false, pedidoNf: false, modeloNf: false, serieNf: false, numeroNf: false,
    emissaoNf: false, valorBcIcmsNf: false, valorIcmsNf: false, valorBcIcmsStNf: false,
    valorIcmsStNf: false, valorProdutosNf: false, valorTotalNf: false, cfopNf: false, pesoNf: false,
  },
  docCargaNfe: {
    chaveNfe: false, entregaNfe: false,
  },
  docCargaOutros: {
    tipoDoc: false, descricaoDoc: false, numeroDoc: false, emissaoDoc: false, valorDoc: false,
  },
};

export const CAMPOS_DOCUMENTOS_REFERENCIADOS = {
  docReferenciadoNfe: {
    chaveNfe: false,
  },
  docReferenciadoNf: {
    ufEmitenteNf: false, dataEmissaoNf: false, emitenteNf: false, serieNf: false, numeroNf: false,
  },
  docReferenciadoCte: {
    chaveCte: false,
  },
  docReferenciadoCupom: {
    modeloCupom: false, numeroEcfCupom: false, numeroContadorCupom: false,
  },
};

const CAMPOS_TRANSPORTE = {
  modalidadeFrete: false, cnpjTransportador: false, cpfTransportador: false, razaoSocialTransportador: false,
  ieTransportador: false, enderecoTransportador: false, municipioTransportador: false, ufTransportador: false,
};

export const CAMPOS_TRANSPORTE_NFE = {
  transporte: {
    ...CAMPOS_TRANSPORTE,
    valorServicoRetencao: false, valorBcRetencao: false, aliquotaRetencao: false, valorIcmsRetencao: false,
    cfopTransporte: false, codigoMunicipioFatoGerador: false, placaVeiculo: false, ufVeiculo: false,
    rntcVeiculo: false, identificacaoVagao: false, identificacaoBalsa: false,
  },
};

export const CAMPOS_TRANSPORTE_NFCE = {
  transporte: CAMPOS_TRANSPORTE,
};

export const CAMPOS_DADOS_TOTAIS = {
  dadosTotais: {
    totalBcIcms: false, totalIcms: false, totalIcmsDeson: false, totalIcmsFcpUfDest: false,
    totalIcmsInterUfDest: false, totalIcmsInterUfRemet: false, totalFcp: false, totalBcIcmsSt: false,
    totalIcmsSt: false, totalFcpRetidoSt: false, totalFcpRetidoAntSt: false, totalProd: false,
    totalFrete: false, totalSeguro: false, totalDesconto: false, totalImpostoImportacao: false,
    totalIpi: false, totalIpiDevolvido: false, totalPis: false, totalCofins: false, totalOutras: false,
    totalValor: false, valor: false, totalTributos: false, impostoSeletivo: false, bcIbsCbs: false,
    ibsUfDiferimento: false, ibsUfDevolucao: false, totalIbsUf: false, ibsMunDiferimento: false,
    ibsMunDevolucao: false, totalIbsMun: false, totalIbs: false, creditoPresumidoIbs: false,
    creditoPresumidoIbsCondSusp: false, cbsDiferimento: false, cbsDevolucaoTrib: false, totalCbs: false,
    creditoPresumidoCbs: false, creditoPresumidoCbsCondSusp: false, ibsMono: false, cbsMono: false,
    ibsMonoSujRet: false, cbsMonoSujRet: false, ibsMonoRetidoAnt: false, cbsMonoRetidoAnt: false,
    ibsEstornado: false, cbsEstornada: false, nfeIbsCbsIs: false, valorAReceber: false,
  },
};

export const CAMPOS_DADOS_ICMS_CTE = {
  dadosIcms: {
    cst: false, valorBc: false, aliquota: false, valorIcms: false, percReducaoBc: false, bcIcmsStRet: false,
    valorIcmsStRet: false, aliquotaIcmsStRet: false, valorCredIcms: false, percRedBcOutraUf: false, bcIcmsOutraUf: false,
    aliquotaIcmsOutraUf: false, valorIcmsOutraUf: false,
  },
};

export const CAMPOS_DADOS_ICMS_UF_FIM = {
  dadosIcmsUfFim: {
    bcUfFim: false, percIcmsFcpUfFim: false, aliquotaInternaUfFim: false, aliquotaInterestUfEnvolvidas: false,
    valorIcmsFcpUfFim: false, valorIcmsUfFim: false, valorIcmsUfInicio: false,
  },
};

export const CAMPOS_DADOS_TRIBUTOS_FEDERAIS = {
  dadosTributosFederais: {
    pis: false, cofins: false, ir: false, inss: false, csll: false,
  },
};

export const CAMPOS_DADOS_IBS_CBS = {
  dadosIbsCbs: {
    cstIbsCbs: false, cClassTrib: false, indDoacao: false, valorBcIbsCbs: false, aliquotaIbsUf: false, percDifUf: false, valorDifUf: false,
    tribDevolvidoUf: false, percRedAliquotaUf: false, aliquotaEfeIbsUf: false, valorIbsUf: false, aliquotaIbsMun: false,
    percDifMun: false, valorDifMun: false, tribDevolvidoMun: false, percRedAliquotaMun: false, aliquotaEfeIbsMun: false,
    valorIbsMun: false, valorIbsUfMun: false, aliquotaCbs: false, percDifCbs: false, valorDifCbs: false, valorCbsDevolvido: false,
    percRedCbs: false, aliquotaEfetivaCbs: false, valorCbs: false, cstTribRegular: false, codClassTribRegular: false,
    aliquotaEfetivaRegUf: false, valorTribRegUf: false, aliquotaEfetivaRegMun: false, valorTribRegMun: false, aliquotaEfeRegCbs: false,
    valorTribRegCbs: false, aliquotaIbsCompGovUf: false, valorTribIbsCompGovUf: false, aliqIbsCompGovMun: false, valorTribCompGovMun: false,
    aliquotaIbsCbsCompGov: false, valorTribComprasGovCbs: false, valorIbsEstorno: false, valorCbsEstorno: false,
  },
};

export const CAMPOS_DADOS_ITEM_TOTAL = {
  dadosTotalItem: {
    valorTotalItemNfe: false,
  },
};

export const CAMPOS_DADOS_ITEM_DOCUMENTO_REFERENCIADO = {
  dadosItemDocumentoReferenciado: {
    chaveDfeReferenciado: false, itemReferenciado: false,
  },
};

export const CAMPOS_DADOS_ICMS = {
  dadosIcms: {
    origemMercadoria: false, cst: false, csosn: false, modalidadeIcms: false, percentualReducaoBcIcms: false,
    valorBcIcms: false, aliquotaIcms: false, valorIcmsOperacao: false, percentualDiferimento: false,
    valorIcmsDiferido: false, valorIcms: false, baseCalculoFcp: false, percentualFcp: false,
    valorFcp: false, modalidadeIcmsSt: false, percentualMargemValorAdicionadoIcmsSt: false,
    percentualReducaoBcIcmsSt: false, valorBcIcmsSt: false, aliquotaIcmsSt: false, valorIcmsSt: false,
    valorBcFcpRetidoSt: false, percentualBcFcpRetidoSt: false, valorFcpRetidoSt: false, percentualBcOperacaoPropria: false,
    ufIcmsStDevido: false, valorBcIcmsStRetido: false, aliquotaConsumidorFinal: false, valorIcmsProprioSubstituto: false,
    valorIcmsStRetido: false, valorBcFcpRetidoAnteriormenteSt: false, percentualBcFcpRetidoAnteriormenteSt: false,
    valorFcpRetidoAnteriormenteSt: false, valorIcmsDesonerado: false, motivoDesoneracaoIcms: false,
    aliquotaCreditoSimples: false, valorCreditoIcms: false, valorBcIcmsStUfDestino: false, valorIcmsStUfDestino: false,
    percentualReducaoBcEfetiva: false, valorBcEfetiva: false, aliquotaIcmsEfetiva: false, valorIcmsEfetivo: false,
  },
};

export const CAMPOS_DADOS_ICMS_INTERESTADUAL = {
  dadosIcmsInterestadual: {
    valorBcIcmsUfDestino: false, valorBcFcpUfDestino: false, percentualIcmsFcpUfDestino: false,
    aliquotaInternaUfDestino: false, aliquotaInterestadualUfsEnvolvidas: false, percentualPartilhaIcmsInterestadual: false,
    valorIcmsFcpUfDestino: false, valorIcmsInterestadualUfDestino: false, valorIcmsInterestadualUfRemetente: false,
  },
};

export const CAMPOS_DADOS_IMPOSTO_IMPORTACAO = {
  dadosImpostoImportacao: {
    valorBcImpostoImportacao: false, despesasAduaneiraImpostoImportacao: false,
    valorImpostoImportacao: false, iofImpostoImportacao: false,
  },
};

export const CAMPOS_DADOS_IPI = {
  dadosIpi: {
    cnpjProdutor: false, codigoSeloControle: false, qtdSeloControle: false,
    codigoEnquadramento: false, cstIpi: false, valorBcIpi: false, qtdUnidadePadrao: false,
    valorUnidadeTributavelIpi: false, aliquotaIpi: false, valorIpi: false,
  },
};

export const CAMPOS_DADOS_PIS = {
  dadosPis: {
    cstPis: false, valorBcPis: false, aliquotaPercentualPis: false,
    valorPis: false, qtdVendidaPis: false, aliquotaReaisPis: false,
  },
};

export const CAMPOS_DADOS_PIS_ST = {
  dadosPisSt: {
    valorBcPisSt: false, aliquotaPercPisSt: false, qtdVendidaPisSt: false,
    aliquotaReaisPisSt: false, valorPisSt: false,
  },
};

export const CAMPOS_DADOS_COFINS = {
  dadosCofins: {
    cstCofins: false, valorBcCofins: false, aliquotaPercentualCofins: false,
    qtdVendidaCofins: false, aliquotaReaisCofins: false, valorCofins: false,
  },
};

export const CAMPOS_DADOS_COFINS_ST = {
  dadosCofinsSt: {
    valorBcCofinsSt: false, aliquotaPercCofinsSt: false, qtdVendidaCofinsSt: false,
    aliquotaReaisCofinsSt: false, valorCofinsSt: false,
  },
};

export const CAMPOS_DADOS_TRIBUTOS_DEVOLVIDOS = {
  dadosTributosDevolvidos: {
    percMercDevolvidaTribDevolvidos: false, ipiDevolvidoTribDevolvidos: false,
  },
};

export const CAMPOS_DADOS_IMPOSTO_SELETIVO = {
  dadosImpostoSeletivo: {
    cstImpostoSeletivo: false, codClassTribImpostoSeletivo: false, valorBcImpostoSeletivo: false,
    aliquotaImpostoSeletivo: false,
    aliquotaEspecificaImpostoSeletivo: false, unidadeImpostoSeletivo: false, quantidadeImpostoSeletivo: false,
    valorIsImpostoSeletivo: false,
  },
};

export const CAMPOS_DADOS_ITEM_IBS_CBS = {
  dadosItemIbsCbs: {
    cstIbsCbs: false, codClassTribIbsCbs: false, indicadorDoacaoIbsCbs: false,
    valorBcIbsCbs: false, aliquotaIbsUf: false, percDiferimentoIbsUf: false, valorDiferimentoIbsUf: false,
    valorTribDevolvidoIbsUf: false, percRedAliqCClassTribIbsUf: false, aliquotaEfetivaIbsUf: false, valorIbsUf: false,
    aliquotaIbsMun: false, percDiferimentoIbsMun: false, valorDiferimentoIbsMun: false, valorTribDevolvidoIbsMun: false,
    percRedAliqCClassTribIbsMun: false, aliquotaEfetivaIbsMun: false, valorIbsMun: false, valorIbs: false,
    aliquotaCbs: false, percDiferimentoCbs: false, valorDiferimentoCbs: false, valorTribDevolvidoCbs: false,
    percRedAliqCClassTribCbs: false, aliquotaEfetivaCbs: false, valorCbs: false, cstIbsCbsTribReg: false,
    codClassTribIbsCbsTribReg: false, aliquotaIbsUfTribReg: false, tribIbsUfTribReg: false,
    aliquotaIbsMunTribReg: false, tribIbsMunTribReg: false, aliquotaCbsTribReg: false, tribCbsTribReg: false,
    aliquotaIbsUfComprasGov: false, tribIbsUfComprasGov: false, aliquotaIbsMunComprasGov: false,
    tribIbsMunComprasGov: false, aliquotaCbsComprasGov: false, tribCbsComprasGov: false,
    qtdTribImpostoMonofasico: false, aliquotaAdRemIbsImpostoMonofasico: false,
    aliquotaAdRemCbsImpostoMonofasico: false, valorIbsMonoImpostoMonofasico: false,
    valorCbsMonoImpostoMonofasico: false, qtdTribRetencaoImpostoMonofasico: false,
    aliquotaAdRemIbsRetencaoImpostoMonofasico: false, valorIbsRetencaoImpostoMonofasico: false,
    aliquotaAdRemCbsRetencaoImpostoMonofasico: false, valorCbsRetencaoImpostoMonofasico: false,
    qtdTribRetAnterImpostoMonofasico: false, aliquotaAdRemIbsRetAnterImpostoMonofasico: false,
    valorIbsRetAnterImpostoMonofasico: false, aliquotaAdRemCbsRetAnterImpostoMonofasico: false,
    valorCbsRetAnterImpostoMonofasico: false, percDifIbsImpostoMonofasico: false,
    ibsMonDiferImpostoMonofasico: false, percDifCbsImpostoMonofasico: false, cbsMonDiferImpostoMonofasico: false,
    totalIbsMonoImpostoMonofasico: false, totalCbsMonoImpostoMonofasico: false, valorIbsTransfCredito: false,
    valorCbsTransfCredito: false, anoMesAjusteCompetencia: false, valorIbsAjusteCompetencia: false,
    valorCbsAjusteCompetencia: false, valorIbsEstornoCredito: false, valorCbsEstornoCredito: false,
    valorBcCredPresumOperacao: false, codClassifCredPresumOperacao: false, percCredPresumIbs: false,
    valorCredPresumIbs: false, valorCondSuspensivaCredPresumIbs: false, percCredPresumCbs: false,
    valorCredPresumCbs: false, valorCondSuspensivaCredPresumCbs: false, anoMesCredPresumIbsSobSaldoZfm: false,
    tipClassifCredPresumIbsSobSaldoZfm: false, valorCredPresumIbsSobSaldoZfm: false,
  },
};

export const CAMPOS_COBRANCA = {
  cobranca: {
    faturaNumero: false, faturaValorOriginal: false, faturaValorDesconto: false, faturaValorLiquido: false,
  },
  parcela: {
    parcelaNumero: false, parcelaDataVencimento: false, parcelaValor: false,
  },
};

export const CAMPOS_PAGAMENTO = {
  pagamento: {
    forma: false, meio: false, valorPagamento: false, troco: false,
  },
  cartao: {
    tipoIntegracao: false, cnpjCredenciadora: false, bandeira: false, numAutorizacao: false,
  },
};

export const CAMPOS_LOCAL_RETIRADA = {
  localRetirada: {
    localRetiradaCnpj: false, localRetiradaCpf: false, localRetiradaRazaoSocial: false, localRetiradaLogr: false,
    localRetiradaNum: false, localRetiradaCompl: false, localRetiradaBairro: false, localRetiradaMun: false,
    localRetiradaUf: false, localRetiradaCep: false, localRetiradaPais: false, localRetiradaFone: false,
    localRetiradaEmail: false, localRetiradaIe: false,
  },
};

export const CAMPOS_LOCAL_ENTREGA = {
  localEntrega: {
    localEntregaCnpj: false, localEntregaCpf: false, localEntregaRazaoSocial: false, localEntregaLogr: false,
    localEntregaNum: false, localEntregaCompl: false, localEntregaBairro: false, localEntregaMun: false,
    localEntregaUf: false, localEntregaCep: false, localEntregaPais: false, localEntregaFone: false,
    localEntregaEmail: false, localEntregaIe: false,
  },
};

export const CAMPOS_COMPONENTE = {
  componente: {
    componenteNome: false, componenteValor: false,
  },
}

export const CAMPOS_QTD_CARGA = {
  qtdCarga: {
    qtdCargaUnMedida: false, qtdCargaTipoMedida: false, qtdCargaQuantidade: false,
  },
}
